(() => {
  const incorrect = /\bwarrenty\b/gi;
  const excludedTags = new Set(['SCRIPT', 'STYLE', 'NOSCRIPT', 'TEXTAREA', 'CODE', 'PRE']);

  const replacement = (match) => {
    if (match === match.toUpperCase()) return 'WARRANTY';
    if (match.charAt(0) === match.charAt(0).toUpperCase()) return 'Warranty';
    return 'warranty';
  };

  const corrected = (value) => String(value || '').replace(incorrect, replacement);

  const fixTextNode = (node) => {
    if (!node?.nodeValue || excludedTags.has(node.parentElement?.tagName)) return;
    const next = corrected(node.nodeValue);
    if (next !== node.nodeValue) node.nodeValue = next;
  };

  const fixElement = (element) => {
    if (!(element instanceof Element) || excludedTags.has(element.tagName)) return;

    ['title', 'aria-label', 'alt', 'placeholder'].forEach((attribute) => {
      if (!element.hasAttribute(attribute)) return;
      const current = element.getAttribute(attribute);
      const next = corrected(current);
      if (next !== current) element.setAttribute(attribute, next);
    });
  };

  const fixTree = (root = document) => {
    if (root.nodeType === Node.TEXT_NODE) {
      fixTextNode(root);
      return;
    }

    if (root instanceof Element) fixElement(root);

    const walker = document.createTreeWalker(
      root,
      NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_TEXT
    );

    let node;
    while ((node = walker.nextNode())) {
      if (node.nodeType === Node.TEXT_NODE) fixTextNode(node);
      else fixElement(node);
    }
  };

  const boot = () => {
    fixTree(document);

    if (!document.body || !window.MutationObserver) return;

    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'characterData') {
          fixTextNode(mutation.target);
          return;
        }

        mutation.addedNodes.forEach((node) => fixTree(node));

        if (mutation.type === 'attributes') {
          fixElement(mutation.target);
        }
      });
    }).observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['title', 'aria-label', 'alt', 'placeholder']
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => fixTree(event.target));
})();